import { InputHTMLAttributes, MutableRefObject } from 'react';

type TUploadInputProps = {
  hiddenFileInput: MutableRefObject<HTMLInputElement | null>;
  handleFiles: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
  directory?: boolean;
  [x: string]: any;
};

const UploadInput = ({ hiddenFileInput, handleFiles, accept, multiple, directory }: TUploadInputProps) => {
  const handleChange: InputHTMLAttributes<HTMLInputElement>['onChange'] = (event) => {
    if (!event.target.files || !event.target.files.length) return;
    handleFiles(Array.from(event.target.files));
    if (hiddenFileInput.current) hiddenFileInput.current.value = '';
  };

  const directoryProps = directory ? { webkitdirectory: '', directory: '' } : {};

  return (
    <input
      type="file"
      accept={accept}
      multiple={multiple}
      onChange={handleChange}
      ref={hiddenFileInput}
      {...directoryProps}
      style={{
        position: 'absolute',
        top: '-9999px',
      }} // Make the file input element invisible
    />
  );
};

export { UploadInput };
